// API Configuration for DeckForge

export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'https://v0tyux7ti4.execute-api.us-east-1.amazonaws.com/prod/').replace(/\/$/, '');

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: `${API_BASE_URL}/api/auth/register`,
    LOGIN: `${API_BASE_URL}/api/auth/login`,
    LOGOUT: `${API_BASE_URL}/api/auth/logout`,
    RESET_PASSWORD: `${API_BASE_URL}/api/auth/reset-password`,
    VERIFY_EMAIL: `${API_BASE_URL}/api/auth/verify-email`,
  },
  USER: {
    PROFILE: `${API_BASE_URL}/api/user/profile`,
    UPDATE: `${API_BASE_URL}/api/user/profile`,
    DELETE: `${API_BASE_URL}/api/user/account`,
  },
  SUBSCRIPTIONS: {
    PLANS: `${API_BASE_URL}/api/subscriptions/plans`,
    CREATE_CHECKOUT_SESSION: `${API_BASE_URL}/api/subscriptions/create-checkout-session`,
    SUBSCRIBE: `${API_BASE_URL}/api/subscriptions/subscribe`,
    CHANGE_PLAN: `${API_BASE_URL}/api/subscriptions/change-plan`,
    CANCEL: `${API_BASE_URL}/api/subscriptions/cancel`,
    USAGE: `${API_BASE_URL}/api/subscriptions/usage`,
  },
  PRESENTATIONS: {
    LIST: `${API_BASE_URL}/api/presentations`,
    CREATE: `${API_BASE_URL}/api/presentations/create`,
    UPLOAD: `${API_BASE_URL}/api/presentations/upload`,
    DETAILS: (id: string) => `${API_BASE_URL}/api/presentations/${id}`,
    UPDATE: (id: string) => `${API_BASE_URL}/api/presentations/${id}`,
    DELETE: (id: string) => `${API_BASE_URL}/api/presentations/${id}`,
    DOWNLOAD: (id: string) => `${API_BASE_URL}/api/presentations/${id}/download`,
    EXPORT: (id: string) => `${API_BASE_URL}/api/presentations/${id}/export`,
  },
  UPLOAD: `${API_BASE_URL}/api/upload`,
  NOTIFICATIONS: {
    SSE: `${API_BASE_URL}/api/notifications/sse`,
    STATS: `${API_BASE_URL}/api/notifications/stats`,
    TEST: `${API_BASE_URL}/api/notifications/test`,
  },
};